import generateBaseImportFromStage from "@/store/baseImportFromStage";

export const namespaced = true;

const baseImportFromStage = generateBaseImportFromStage({url: '/loads/'});

export const state = {
    ...baseImportFromStage.state,
};

export const mutations = {
    ...baseImportFromStage.mutations,
};

export const actions = {
    ...baseImportFromStage.actions,
    async importLoadsFromStage(
        {commit, dispatch},
        {sourceSchematisationStageId, targetSchematisationStageId}
    ) {
        try {
            commit('TOGGLE_IMPORT_FROM_STAGE_LOADING');
            const {
                imported_uniform_loads,
                imported_tree_loads,
            } = await dispatch("importFromStage", {
                import_option: {
                    source_stab_schematisation_stage_id: sourceSchematisationStageId,
                    target_stab_schematisation_stage_id: targetSchematisationStageId,
                },
                stab_schematisation_stage: targetSchematisationStageId,
            });
            const loadMapping = {
                uniformLoads: imported_uniform_loads,
                treeLoads: imported_tree_loads,
            }
            for (const [store, importedItems] of Object.entries(loadMapping)) {
                commit(`${store}/SET_ITEMS`, importedItems, {root: true});
            }
        } catch (e) {
            console.log(e);
        } finally {
            commit('TOGGLE_IMPORT_FROM_STAGE_LOADING');
        }
    }
};
